/*
  Pedlock: sign-in through KwikPass (GoKwik's mobile-number OTP login).

  The KwikPass app embed loads its scripts on every page, but with this
  theme's header it doesn't attach itself to the account buttons. This file
  does that:
  - Signed-out visitors: the header account icon and every "Log in" /
    "Create account" link open the KwikPass OTP window instead of Shopify's
    own login page.
  - Signed-in customers: "Log out" also clears the KwikPass session, so the
    next visitor on the same device isn't signed back in.
  If KwikPass hasn't loaded (blocked or down), nothing is intercepted and the
  links keep working as normal Shopify login links.
*/
(() => {
  const script = document.currentScript;
  const signedIn = script && script.dataset.customer === 'true';
  const kwikpassReady = (name) => typeof window[name] === 'function';

  // Shopify login and sign-up addresses (classic and new customer accounts)
  const isLoginLink = (anchor) => {
    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return false;
    }
    if (url.origin === window.location.origin) {
      return url.pathname.includes('/customer_authentication/')
        || url.pathname.startsWith('/account/login')
        || url.pathname.startsWith('/account/register');
    }
    return url.hostname === 'shopify.com' && /^\/\d+\/account/.test(url.pathname);
  };

  const openKwikpass = (event) => {
    event.preventDefault();
    event.stopPropagation(); // keeps the theme's own account menu from opening as well
    window.kpHandleLogin('/account');
  };

  // Capture phase, so this runs before the theme's own click handlers
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;

    if (signedIn) {
      const logout = target.closest('[data-pl-logout]');
      if (logout && kwikpassReady('handleLogout')) {
        event.preventDefault();
        event.stopPropagation();
        window.handleLogout(logout.dataset.plLogout);
      }
      return;
    }

    if (!kwikpassReady('kpHandleLogin')) return;
    if (target.closest('button.header-icon-account')) return openKwikpass(event);
    const anchor = target.closest('a[href]');
    if (anchor && isLoginLink(anchor)) openKwikpass(event);
  }, true);
})();
